<div class="mainCT">
  <div class="inputCt" floatLabel="never">
    <mat-icon svgIcon="search_grey" class="inputIcon"></mat-icon>
    <input
      type="text"
      class="inputDevice"
      placeholder="Select a Container Type"
      aria-label="String"
      matInput
      [formControl]="ctControl"
      />
  </div>
  <div class="ctItemsHolder">
    @for (ct of filteredContainerTypes | async; track ct) {
      <div
        class="ctOptions"
        (click)="selectCt(ct)"
        >
        <div class="label">{{ ct.code }} - {{ ct.label }}</div>
        <div class="arrow">></div>
      </div>
    }
  </div>

  @if (connectionError) {
    <div class="connectionError">
      Unable to reach the server. Please check your internet connection.
    </div>
  }
</div>
